import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startModifyForm } from '../../../redux/actions/form';
import { TitleBlock } from '../../../components/blocks/TitleBlock';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { Radiolist } from '../../../components/inputs/Radiolist';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { GenderIdentity } from '../../../enums/GenderIdentity';
import { GenderAtBirth } from '../../../enums/GenderAtBirth';
import { SexualOrientation } from '../../../enums/SexualOrientation';
import { FORM_TYPES, getStepData } from '../../../enums/Steps';
import { useLanguage } from "../../../hooks/useLanguage";

export const JourneyGenderForm = (props) => {
  const form = useSelector((state) => state.form[0]);
  const dispatch = useDispatch();
  const { t } = useLanguage()

  const handleGenderIdentitySelect = (genderIdentity) => {
    dispatch(startModifyForm({ ...form, patientGenderIdentity: genderIdentity }));
  };

  const handleGenderAtBirthSelect = (genderAtBirth) => {
    dispatch(startModifyForm({ ...form, patientGenderAtBirth: genderAtBirth }));
  };

  const handleSexualOrientationSelect = (sexualOrientation) => {
    dispatch(startModifyForm({ ...form, patientSexualOrientation: sexualOrientation }));
  };

  const [validation, setValidation] = useState(false);
  const validate = () => {
    setValidation(true);
  };

  const step = 'gender';
  const { nextStep, prevStep, currentStepIndicator } = getStepData(step, FORM_TYPES.journey, t);

  const getTranslatedOptions = (options) =>
      options.map(option => ({
        ...option,
        name: t(option.value)
      }));

  const translatedGenderIdentityOptions = getTranslatedOptions(GenderIdentity);
  const translatedGenderAtBirthOptions = getTranslatedOptions(GenderAtBirth);
  const translatedSexualOrientationOptions = getTranslatedOptions(SexualOrientation);

    const actionBarCopy = t('5_of_5');
    // const translatedActionBarCopy = actionBarCopy === '5_of_5' ? "5 of 5" : actionBarCopy

  return (
    <React.Fragment>
      <ProgressBlock value1={currentStepIndicator} value2={0} />
      <div className="inner-form-container">
        <TitleBlock copy={t('journey_gender_question_1')} />
        <Radiolist
          options={translatedGenderIdentityOptions}
          isRows={true}
          selected={form.patientGenderIdentity}
          handleSelect={handleGenderIdentitySelect}
          validation={validation}
        />

        <TitleBlock copy={t('journey_gender_question_2')} />
        <Radiolist
          options={translatedGenderAtBirthOptions}
          isRows={true}
          selected={form.patientGenderAtBirth}
          handleSelect={handleGenderAtBirthSelect}
          validation={validation}
        />

        <TitleBlock copy={t('journey_gender_question_3')} />
        <Radiolist
          options={translatedSexualOrientationOptions}
          isRows={true}
          selected={form.patientSexualOrientation}
          handleSelect={handleSexualOrientationSelect}
          validation={validation}
        />
      </div>
      <ActionBar
        prevState={prevStep}
        handleValidation={validate}
        copy={actionBarCopy}
        nextState={
          form.patientGenderIdentity
            ? form.patientGenderAtBirth
              ? form.patientSexualOrientation
                ? nextStep
                : ''
              : ''
            : ''
        }
      />
    </React.Fragment>
  );
};
